import React from 'react'

import styles from './SectionTitle.module.scss'

export type StyledSectionTitleProps = {
  className?: string
  text: string
}

export const StyledSectionTitle: React.FC<StyledSectionTitleProps> = ({ className, text }) => {
  return (
    <h2 className={`text-black font-semibold text-center text-2XL desktop:text-4XL mb-8 ${styles.h2} ${className || ''}`}>{text}</h2>
  )
}
